import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, of, from, switchMap, tap } from 'rxjs';
import { OfflineQueueService } from '@services/offline-queue.service';
import { CacheService } from '@services/cache.service';

export const offlineInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const offlineQueue = inject(OfflineQueueService);
  const cacheService = inject(CacheService);

  // GET request
  if (req.method === 'GET') {
    if (!navigator.onLine) {
      return new Observable<HttpEvent<unknown>>(observer => {
        cacheService.get(req.url).then(cached => {
          if (cached) {
            observer.next(new HttpResponse({ status: 200, body: cached }));
          } else {
            observer.error({ status: 0, message: 'No cached data' });
          }
          observer.complete();
        });
      });
    } else {
      return next(req).pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
            cacheService.save(req.url, event.body);
          }
        })
      );
    }
  }

  // POST/PUT/DELETE request offline
  if (!navigator.onLine && ['POST', 'PUT', 'DELETE'].includes(req.method)) {
    // تخزين الطلب في IndexedDB وتحويله إلى Observable
    return from(offlineQueue.addRequest(req)).pipe(
      switchMap(() =>
        of(
          new HttpResponse({
            status: 200,
            body: { message: 'تم التخزين مؤقتاً' },
          })
        )
      )
    );
  }

  // باقي الحالات
  return next(req);
};
